import type { QueryClient } from "@tanstack/react-query";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import type { GetAppointmentTypeResponse } from "@/openapi/generated/models";
import { GetAppointmentTypeResponseFromJSON } from "@/openapi/generated/models";

export async function prefetchAppointmentTypes(
  queryClient: QueryClient,
  accessToken: string,
) {
  const service = createAuthenticatedApi(
    PrivatesAppointmentsApi,
    accessToken,
  );

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.AppointmentTypes],
    queryFn: async (): Promise<Array<GetAppointmentTypeResponse>> => {
      const response = await service.apiAppointmentTypesGetRaw({});
      const jsonData = await response.raw.json();
      return jsonData.map((item: any) => GetAppointmentTypeResponseFromJSON(item));
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return queryClient;
}
